import { render, staticRenderFns } from "./BlockImagesSlider.vue?vue&type=template&id=3567679a"
import script from "./BlockImagesSlider.vue?vue&type=script&lang=js"
export * from "./BlockImagesSlider.vue?vue&type=script&lang=js"
import style0 from "./BlockImagesSlider.vue?vue&type=style&index=0&id=3567679a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports